import { SearchIcon } from '@heroicons/react/outline'
import { Backdrop, CircularProgress, Pagination, Tab, Tabs } from '@mui/material'
import { useEffect, useState } from 'react'
import { PencilSquare } from 'react-bootstrap-icons'
import { useDispatch, useSelector } from 'react-redux'
import EditProduct from '../Controllers/EditProduct'
import { FormatAmount, formatDate } from '../Controllers/FormatAmount'
import Popup from '../Controllers/Popup'
import { getAllProducts, updateProduct } from '../Redux/Action/catelog.action'
import NO_PHOTO from '../assets/nophoto.png'
const ProductTable = () => {
  const dispatch = useDispatch();
  const { allProducts, producLoader, updateProducLoader } = useSelector((state) => state.catelogReducer);
  const { staffInfo } = useSelector((state) => state?.authReducer)
  const [tabValue, setTabValue] = useState("")
  const [Page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [search, setSearch] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState();
  var startRecord = (allProducts?.data?.currentPage - 1) * limit + 1;
  var endRecord = Math.min(
    allProducts?.data?.currentPage * limit,
    allProducts?.data?.totalRecords,
  );
  useEffect(() => {
    if (!search || search.length > 2) {
      dispatch(getAllProducts(Page, limit, search, '', tabValue, ''))
    }
  }, [search, Page, tabValue])
  const closePopup = () => {
    setIsEdit(false);
  }
  return (
    <>
      {producLoader || updateProducLoader && <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={producLoader || updateProducLoader}
        className='flex flex-col'
      >
        <CircularProgress color='inherit' />
        <p>Loading...</p>
      </Backdrop>}
      <div className='flex flex-col gap-5'>
        <div className="header flex flex-wrap gap-4 items-center justify-between">
          <Tabs textColor='black' className='border-b' TabIndicatorProps={{ style: { backgroundColor: 'black' } }} // Black indicator for active tab
            value={tabValue} onChange={(e, v) => setTabValue(v)} aria-label="basic tabs example">
            <Tab label="Newest" value={"Newest"} />
            <Tab label="Best Seller" value={"BestSeller"} />
            {/* <Tab label="Discount Products" value={"product_discount"} /> */}
          </Tabs>
          <div className='flex gap-2 items-center justify-end'>
            <div className='relative'>
              <SearchIcon className='input-icon w-5 h-5' />
              <input type='text' placeholder='Type 3 character to search' className='!pl-10' value={search} onChange={(e) => setSearch(e.target.value)} />
            </div>
            <button className='square-btn'><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z" />
            </svg>
            </button>
            <button className='square-btn'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
              </svg>
            </button>
          </div>
        </div>
        <div className='rounded-[10px] overflow-auto border border-color'>
          {allProducts?.data?.records?.length > 0 || allProducts?.data.length > 0 ? <table className='w-full'>
            <thead>
              <tr>
                <td className='max-w-[100px]'>Products</td>
                <td>prices</td>
                <td>SKU ID</td>
                <td>Qty</td>
                <td className='w-full text-right'>Status</td>
                <td className='text-right'>created at</td>
                <td className='w-full text-right'>action</td>
              </tr>
            </thead>
            <tbody className='divide-y border-color'>
              {allProducts?.data?.records?.map((elem, index) => (
                <tr key={elem?._id}>
                  <td className='flex h-[60px] items-center'>
                    <div className='min-w-[50px] min-h-[50px] max-w-[50px] max-h-[50px] flex items-center justify-center rounded-[6px] overflow-hidden'>
                      <img src={elem?.additional_images?.[0] || NO_PHOTO} className='max-h-full max-w-full inline-block object-contain' />
                    </div>
                    <span className='text-ellipsis ms-2 inline-block whitespace-nowrap'>{elem?.product_name}</span>
                  </td>
                  <td>{FormatAmount((elem?.selling_price || elem?.mrp), staffInfo?.client)}</td>
                  <td>{elem?.sku_id ? "#" + elem?.sku_id : '-'}</td>
                  <td>{elem?.quantity}</td>
                  <td className='w-full text-right'>
                    <span className={`${elem?.published ? 'text-[#238823] bg-[#F4FDF5]' : 'bg-[#fdf4f4] text-[#c9010e]'} status-bedge`}>{elem?.published ? "Active" : "In active"}</span>
                  </td>
                  <td className='whitespace-nowrap text-right'>{formatDate(elem?.createdAt, staffInfo?.client)}</td>
                  <td className='w-full relative text-right'>
                    <div className='space-x-3 w-full flex justify-end items-center'>
                      <label class="relative h-5 me-5 inline-block cursor-pointer">
                        <input type="checkbox" class="peer invisible" checked={elem?.published} onChange={(e) => dispatch(updateProduct(elem?._id, {published: e.target.checked}))} />
                        <span class="absolute top-0 left-0 w-9 h-5 cursor-pointer rounded-full bg-[#F4FDF5] border border-[#238823] transition-all duration-100 peer-checked:bg-[#F4FDF5]"></span>
                        <span class="absolute top-[50%] -translate-y-[50%] left-[4px] w-[13px] h-[13px] bg-[#238823] rounded-full z-10 transition-all duration-100 peer-checked:translate-x-[16px]"></span>
                      </label>
                      <PencilSquare className='cursor-pointer' onClick={(e) => { e.stopPropagation(); setIsEdit(true); setEditData(elem) }} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
            :
            <div className='w-full h-auto bg-white flex items-center justify-center border mb-2.5 rounded-[6px] p-5 mt-4'>
              No Product Found
            </div>}
        </div>
        {allProducts?.data?.totalPages ? (
          <div className='bg-white border main-border-color flex flex-1 p-5 items-center justify-between pagination overflow-hidden rounded-[6px] mt-4'>
            <span className='text-sm font-medium'>
              {limit === 'all'
                ? `${allProducts?.data?.totalRecords}` + ' ' + `records`
                : `${startRecord} - ${endRecord} of ${allProducts?.data?.totalRecords
                } records`}
            </span>
            <div>
              {allProducts?.data?.totalPages !== 1 ? (
                <Pagination
                  count={allProducts?.data?.totalPages}
                  page={Page}
                  onChange={(e, v) => setPage(v)}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <Popup showPopup={isEdit} closePopup={closePopup} callComponant={<EditProduct editData={editData} setIsEdit={setIsEdit} />} closebtn={true} />
    </>
  )
}

export default ProductTable